const removeSpaces = (value: string) => {
    return (value ?? "").replace(/[^a-zA-Z ]/g, "").toLowerCase();
}

export default removeSpaces;